<template>
  <div class="content">
    <ModalPadrao
      :showModal="showModal"
      :ifSubheadingTop="true"
      :SubheadingTop="
        action == 'cancel'
          ? 'Deseja cancelar recorrência ?'
          : 'Deseja renovar a recorrência ?'
      "
      :ifIcon="true"
      :Icon="'delete'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="showModal = false"
      @btnDois="
        action == 'cancel' ? cancelarRecorrencia() : renovarRecorrencia()
      "
    ></ModalPadrao>

    <ModalEditRecorrencia
      :recurrent="recurrent"
      :showModal="showModalEditRecorrencia"
      @btnNao="showModalEditRecorrencia = false"
      @btnSim="editRecurrent"
    ></ModalEditRecorrencia>

    <ModalCancelRecorrencia
      :recurrent="recurrent"
      :showModal="showModalCancelRecorrencia"
      :cobrarMulta="cobrarMulta"
      :recurrentCancelMulctValue="recurrentCancelMulctValue"
      @btnNao="showModalCancelRecorrencia = false"
      @btnSalvar="cancelarRecorrencia"
    ></ModalCancelRecorrencia>

    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    ></BlockUI>

    <v-card>
      <v-container class="filters">
        <v-card class="card-filter">
          <v-flex>
            <v-flex
              style="background-color: var(--secondary-color); padding: 10px"
            >
              <label style="color: white; font-weight: 600; font-size: 20px"
                >Filtros</label
              >
            </v-flex>
          </v-flex>
          <v-container class="filters">
            <v-row>
              <v-col sm="4" ma-1>
                <v-select
                  v-model="clientsSelected"
                  :items="clientItems"
                  label="Clientes"
                  color="blue darken-4"
                  item-text="name"
                  item-value="id"
                  multiple
                  placeholder="Selecione os clientes"
                  required
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ clientsSelected.length - 1 }} outro(s))
                    </span>
                  </template>
                  <v-list-tile
                    slot="prepend-item"
                    ripple
                    @click="toggle"
                    class="v-list-item v-list-item--link theme--light"
                  >
                    <v-list-tile-action>
                      <v-icon
                        :color="
                          this.clientsSelected != null &&
                          this.clientsSelected.length > 0
                            ? 'blue darken-4'
                            : ''
                        "
                        >{{ icon }}</v-icon
                      >
                    </v-list-tile-action>
                    <v-list-tile-title style="margin-left: 35px">
                      Selecionar todos</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-divider slot="prepend-item" class="mt-2" />
                </v-select>
              </v-col>
              <v-col sm="4" ma-1>
                <v-select
                  v-model="recurrentPackageSelected"
                  :items="recurrentPackageItens"
                  label="Tipo de Assinatura"
                  color="blue darken-4"
                  item-text="name"
                  item-value="id"
                  multiple
                  placeholder="Selecione o tipo de recorrencia"
                  required
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ clientsSelected.length - 1 }} outro(s))
                    </span>
                  </template>
                  <v-list-tile
                    slot="prepend-item"
                    ripple
                    @click="toggleRecurrent"
                    class="v-list-item v-list-item--link theme--light"
                  >
                    <v-list-tile-action>
                      <v-icon
                        :color="
                          this.clientsSelected != null &&
                          this.clientsSelected.length > 0
                            ? 'blue darken-4'
                            : ''
                        "
                        >{{ icon }}</v-icon
                      >
                    </v-list-tile-action>
                    <v-list-tile-title style="margin-left: 35px">
                      Selecionar todos</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-divider slot="prepend-item" class="mt-2" />
                </v-select>
              </v-col>
              <v-col offset-sm="1" sm="2" ma-1
                ><v-btn
                  class="btn-block btn colorApp mb-2 text-white"
                  @click="filtrarRecorrencias"
                >
                  Pesquisar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <v-card-title>
        Assinatura Mensal
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
        <v-tabs>
          <v-tab @click="situation = 'all'">Todas</v-tab>
          <v-tab @click="situation = true">Ativas</v-tab>
          <v-tab @click="situation = false">Canceladas</v-tab>
        </v-tabs>
      </v-card-title>
      <v-data-table
        no-data-text="Nenhum pagamento registrado"
        footer-props-items-per-page-text="Linhas por página"
        :headers="headers"
        :search="search"
        :items="filterBySituation"
        class="table-custom-vue elevation-1 mt-2"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-left">{{ item.id }}</td>
            <td class="text-left">{{ item.client.name }}</td>
            <td class="text-left">{{ item.user.name }}</td>
            <td class="text-left">R$ {{ item.value | formatPrice }}</td>
            <td class="text-left">{{ item.start_date | formatDate }}</td>
            <td class="text-left">{{ item.last_payment | formatDate }}</td>
            <td class="text-left">{{ item.active | formatActive }}</td>
            <td class="layout">
              <ActionButton
                message="Detalhes de uso"
                icon="assignment"
                @onclick="detalhesRecorrencia(item)"
              />
              <!-- <ActionButton
                message="Editar recorrência"
                icon="edit"
                @onclick="openModalEditRecurrent(item)"
              /> -->
              <ActionButton
                v-if="item.active"
                message="Editar recorrência"
                icon="edit"
                @onclick="openModalEditRecurrent(item)"
              />
              <ActionButton
                message="Renovar recorrência"
                icon="refresh"
                @onclick="openModalRenewRecurrent(item)"
              />
              <ActionButton
                v-if="item.active"
                message="Cancelamento de recorrência"
                icon="cancel"
                color="error"
                @onclick="openModalCancelRecurrent(item)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
      <div
        class="modal fade"
        id="add-coupon"
        tabindex="-1"
        role="dialog"
        aria-labelledby="register-driver-modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content"></div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import PromotionUserController from '../../controllers/PromotionUserController';
import CobrancasRecorrentesController from '../../controllers/CobrancasRecorrentesController';
import moment from 'moment';
import NumberHelper from './../../helpers/NumberHelper';
import ModalPadrao from '../shared/ModalPadrao.vue';
import Breadcrumb from '../shared/Breadcrumb.vue';
import ClientController from '../../controllers/ClientController';
import TransactionController from '../../controllers/TransactionController';
import ActionButton from '../shared/ActionButtonsTemplate';
import ModalEditRecorrencia from '../shared/ModalEditRecorrencia.vue';
import ModalCancelRecorrencia from '../shared/ModalCancelRecorrencia.vue';
import UserCreditCardController from '../../controllers/UserCreditCardController';

export default {
  created() {
    this.report();
    this.getClients();
  },
  components: {
    ActionButton,
    ModalPadrao,
    Breadcrumb,
    ModalEditRecorrencia,
    ModalCancelRecorrencia,
  },
  data() {
    return {
      promotionUserController: new PromotionUserController(this.$resource),
      userCreditCardController: new UserCreditCardController(this.$resource),
      transactionController: new TransactionController(this.$resource),
      clientController: new ClientController(this.$resource),
      cobrancasRecorrentesController: new CobrancasRecorrentesController(
        this.$resource
      ),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      json_fields: {
        Nome: 'name',
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Cliente', value: 'client.name' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Valor', value: 'value' },
        { text: 'Data inicial', value: 'start_date' },
        { text: 'Ultimo pagamento', value: 'last_payment' },
        { text: 'Status', value: 'active' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      cobrancasRecorrentes: [],
      showModal: false,
      showPayments: false,
      cobrancaRecorrenteId: null,
      promotion_user_id: null,
      expiration_date: null,
      promotionUserItem: {},
      recurrenceDetails: {},
      situation: 'all',
      showModalEditRecorrencia: false,
      recurrent: {},
      action: null,
      showModalCancelRecorrencia: false,
      cobrarMulta: false,
      recurrentCancelMulctValue: 0,
      clientsSelected: [],
      clientItems: [],
      recurrentPackageSelected: [],
      recurrentPackageItens: [
        { id: 'loyalty', name: 'UseMais / UseMuitoMais'},
        { id: 'recurrent', name: 'Plano Todo Dia'},
      ]
    };
  },
  computed: {
    filterBySituation(value, search, item) {
      return this.cobrancasRecorrentes.filter(i => {
        if (this.situation === 'all') {
          return this.cobrancasRecorrentes;
        } else if (this.situation) {
          return i.active == true;
        } else {
          return i.active == false;
        }
      });
    },
    selecionarTodos() {
      return (
        this.clientsSelected != null &&
        this.clientItems != null &&
        this.clientsSelected.length === this.clientItems.length
      );
    },
    desmarcarSelecao() {
      return (
        this.clientsSelected != null &&
        this.clientsSelected.length > 0 &&
        !this.selecionarTodos
      );
    },
    icon() {
      if (this.selecionarTodos) return 'mdi-close-box';
      if (this.desmarcarSelecao) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  methods: {
    cobraRecorrencia() {
      this.cobrancasRecorrentesController
        .cobraRecorrencia()
        .then(res => {
          // this.report();
          this.$awn.success('foi');
        })
        .catch(error => {
          console.log(error);
          this.$awn.alert('num foi.');
        });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selecionarTodos) {
          this.clientsSelected = [];
        } else {
          this.clientsSelected = [];
          this.clientItems.map(client => {
            this.clientsSelected.push(client.id);
          });
        }
      });
    },
    toggleRecurrent() {
      this.$nextTick(() => {
        if (this.selecionarTodos) {
          this.recurrentPackageSelected = [];
        } else {
          this.recurrentPackageSelected = [];
          this.recurrentPackageItens.map(client => {
            this.recurrentPackageSelected.push(client.id);
          });
        }
      });
    },
    filtrarRecorrencias() {
      this.blockScreen = true;
      this.cobrancasRecorrentes = [];
      this.cobrancasRecorrentesController
        .getRecurrentFilterByClients(this.clientsSelected, this.recurrentPackageSelected)
        .then(res => {
          this.cobrancasRecorrentes = res;
        })
        .finally(() => {
          this.blockScreen = false;
        });
    },
    getClients() {
      this.clientController
        .getAllClientsTypeCondominio()
        .then(res => (this.clientItems = res));
    },
    cancelarRecorrencia(cobrarMulta) {
      this.blockScreen = true;
      this.cobrancasRecorrentesController
        .newCancelRecurrent(this.recurrent.id, cobrarMulta)
        .then(res => {
          this.report();
          this.$awn.success(res.message);
        })
        .catch(error => {
          console.log(error);
          this.$awn.alert('Falha ao desativar oferta.');
        })
        .finally(() => {
          this.showModalCancelRecorrencia = false;
          this.blockScreen = false;
        });
    },

    renovarRecorrencia() {
      this.blockScreen = true;
      this.cobrancasRecorrentesController
        .renewRecurrent(this.cobrancaRecorrenteId)
        .then(res => {
          this.report();
          this.$awn.success(res.message);
        })
        .catch(error => {
          console.log(error);
          this.$awn.alert('Falha ao renovar oferta.');
        })
        .finally(() => {
          this.showModal = false;
          this.blockScreen = false;
        });
    },
    openModalCancelRecurrent(item) {
      this.cobrancasRecorrentesController.verifyMulct(item.id).then(res => {
        this.cobrarMulta = res.data;
        this.recurrentCancelMulctValue = res.mulctValue;
      });
      this.recurrent = item;

      this.showModalCancelRecorrencia = true;
    },

    openModalRenewRecurrent(item) {
      this.action = 'renew';
      this.cobrancaRecorrenteId = item.id;
      this.showModal = true;
    },

    openModalEditRecurrent(item) {
      this.recurrent = item;
      this.showModalEditRecorrencia = true;
    },
    editRecurrent(creditCardId, promotionClientId) {
      if (!creditCardId && !promotionClientId) {
        this.$awn.alert('Selecione alguma opção para realizar alterações.');
        return;
      }

      if (creditCardId)
        this.userCreditCardController
          .updatePattern(creditCardId)
          .then(res => {
            this.$awn.success('Cartão alterado com sucesso!');
            this.report();
            this.showModalEditRecorrencia = false;
          })
          .catch(error => {
            this.$awn.alert('Falha ao alterar cartão.');
          });

      if (promotionClientId) {
        this.cobrancasRecorrentesController
          .requestPlanMigration({
            id: this.recurrent.id,
            user_id: this.recurrent.user.id,
            promotion_client_id: promotionClientId,
          })
          .then(res => {
            this.$awn.success('Migração efetuada com sucesso!');
            this.report();
            this.showModalEditRecorrencia = false;
          })
          .catch(error => {
            this.$awn.alert('Falha ao realizar migração de plano.');
            console.log(error);
          });
      }
    },

    detalhesRecorrencia(item) {
      this.promotionUserController
        .getLastRecurrentPromotionByUserId(item.user.id)
        .then(res => {
          console.log(res)
          const promotionUserId = res.id;
          const routeData = this.$router.resolve({
            name: 'promotion-report-details',
            params: {
              promotion_user_id: promotionUserId,
            },
          });
          window.open(routeData.href, '_blank');
          localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
        });
    },

    report() {
      this.cobrancasRecorrentesController.getRecurrent().then(res => {
        this.cobrancasRecorrentes = res;
      });
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },
    formatDateTime(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
    },
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatActive(vlr) {
      if (vlr) return 'Ativo';
      else return 'Cancelado';
    },
  },
};
</script>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}
.colorApp {
  background-color: var(--secondary-color) !important;
}
.filters {
  max-width: 100% !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
